import { ChangeOrderPlanOptionLocationAttribute } from './changeorderplanoptionlocationattribute';

export class ChangeOrderPlanOptionLocation {
    public id: number;
    public jobChangeOrderPlanOptionId: number;
    public locationGroupCommunityId: number;
    public locationCommunityId: number;
    public locationName: string;
    public loactionGroupLabel: string;
    public quantity: number;
    public action: string;
    public createdBy: string;
    public createdUtcDate: Date;
    public lastModifedBy: string;
    public lastModifiedUtcDate: Date;
    public changeOrderPlanOptionLocationAttributes: ChangeOrderPlanOptionLocationAttribute[];
}